<template>
  <div class="desktop-proposal-footer">
    <div class="footer-bottom is-middle columns is-gapless is-middle">
        <div class="columns is-mobile is-multiline is-gapless" v-on:click="renew()">
            <div class="column is-1 is-narrow is-middle icon-cover">
                <div class="refresh-arrow"></div>
            </div> 
            <div class="column is-narrow detail-item">
              <div>
                <span>{{ $t('buttons.getProposalAgain') }}</span>
              </div>
            </div>
        </div>
    </div>
  </div>  
</template>
<script>

export default {
  name: 'ProposalFooter',
  methods: {
    renew: function () {
      this.$emit('renew')
      this.eventHub.eventHub.$emit('renew-proposal', {})
      var path = this.$route.name.toLowerCase()
      if (path.indexOf('proposalinfo') !== -1) {
        window.history.back()
      }
      if (path.indexOf('payment') !== -1) {
        window.history.go(-3)
      }
    }
  }
}
</script>
<style scoped>
.desktop-proposal-footer {
  height: 50px;
  background-color: var(--light-bg1);
  width: 100%;  
  bottom: 0;
}
.desktop-proposal-footer .footer-bottom {
    padding: 15px;
}
.desktop-proposal-footer .footer-bottom .columns {
    cursor: pointer;
}
.desktop-proposal-footer .detail-item {
  margin-left: 10px !important;
  font-size: 13px;
  line-height: 1.54;
  color: var(--eureko-blue);
  border-right: 1px solid var(--border-color1);
  padding-right: 10px !important;
}
</style>


// WEBPACK FOOTER //
// src/desktop/widget/proposalFooter.vue